import { P2GButton } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
type CTAButtonProps = {
  loading: boolean;
  onClick?: () => void;
  fullWidth: boolean;
};

export default function BackButton({ loading, onClick, fullWidth }: CTAButtonProps) {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  return (
    <P2GButton
      dataTestId="back-button"
      id="btnNext"
      type="button"
      disabled={loading}
      variant="tertiary"
      size="large"
      fullWidth={fullWidth}
      onClick={onClick}
    >
      {t('BACK_BUTTON', { defaultValue: 'Back' })}
    </P2GButton>
  );
}
